/* eslint-disable import/prefer-default-export */
import {
    Conversation,
    ConversationParticipant,
    GetConversationParticipantSignature,
    GetConversationSignature,
} from '@centecomm/portal-service';
import { Streams } from '../../../Types';
import { conversationsActions, ToastMessages } from '../..';
import { ConversationEventTypes, ParticipantJoinedConversation } from '../../../Types/Conversations/Events';
import {
    ParticipantJoinedConversationWrappedEvent,
    WrappedConversationEvent,
} from '../../../Types/Conversations/WrappedEvents';
import { ConversationsActionTypes } from '../../Conversations/actions';

export const participantJoinedConversationHandler = (
    { conversationId, metadata, userId }: Streams.ParticipantJoinedConversationStreamMessage,
    conversations: Record<number, Conversation>,
    events: Record<number, WrappedConversationEvent[]>,
    participants: Record<number, ConversationParticipant[]>,
    currentUserId: number,
    dispatch,
    getConversation: GetConversationSignature,
    getConversationParticipant: GetConversationParticipantSignature,
): void => {
    const { eventDate: JoinedDate } = metadata;

    if (currentUserId === userId && !Object.prototype.hasOwnProperty.call(conversations, conversationId)) {
        getConversation(conversationId).then((conversation: Conversation) => {
            dispatch({
                type: conversationsActions.ADD_CONVERSATION,
                payload: conversation,
            } as ConversationsActionTypes);

            dispatch({
                type: ToastMessages.Actions.ADD_MESSAGE,
                payload: {
                    id: Date.now(),
                    titleI18n: 'conversationsFeature:toast.newConversation.title',
                    messageI18n: 'conversationsFeature:toast.newConversation.message',
                    action: {
                        displayI18n: 'conversationsFeature:toast.newConversation.action',
                        func: () => {
                            dispatch({
                                type: ToastMessages.Actions.ADD_TRIGGER,
                                payload: {
                                    id: Date.now(),
                                    name: ToastMessages.Types.ToastMessageTriggers.OPEN_CONVERSATIONS,
                                },
                            });
                        },
                    },
                } as ToastMessages.Types.ToastMessage,
            });
        });
    }

    if (
        Object.prototype.hasOwnProperty.call(participants, conversationId) &&
        !participants[conversationId].find((p: ConversationParticipant) => p.userId === userId)
    ) {
        getConversationParticipant(conversationId, userId).then((participant: ConversationParticipant) => {
            dispatch({
                type: conversationsActions.ADD_PARTICIPANT_TO_CONVERSATION,
                payload: {
                    conversationId,
                    participant,
                },
            } as ConversationsActionTypes);
        });
    }

    if (Object.prototype.hasOwnProperty.call(events, conversationId)) {
        dispatch({
            type: conversationsActions.ADD_EVENT_TO_CONVERSATION,
            payload: {
                conversationId,
                event: {
                    type: ConversationEventTypes.ParticipantJoinedConversation,
                    event: {
                        conversationId,
                        metadata: {
                            eventDate: JoinedDate,
                            userId,
                        },
                        userId,
                    } as ParticipantJoinedConversation,
                } as ParticipantJoinedConversationWrappedEvent,
            },
        } as ConversationsActionTypes);
    }
};
